import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/images/phonevue-logo.svg';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={scrollToTop}>
          <div className="logo-icon">
            <img src={logo} alt="PhoneVue" />
          </div>
        </Link>
        <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
          <Link 
            to="/about-us" 
            className={`nav-link ${isActive('/about-us')}`}
            onClick={() => setIsMenuOpen(false)}
          >
            About Us
          </Link>
          <Link 
            to="/" 
            className={`nav-link ${isActive('/')}`}
            onClick={() => setIsMenuOpen(false)}
          >
            PhoneVue
          </Link>
          <Link 
            to="/why-phonevue" 
            className={`nav-link ${isActive('/why-phonevue')}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Why PhoneVue
          </Link>
          <Link 
            to="/how-phonevue" 
            className={`nav-link ${isActive('/how-phonevue')}`}
            onClick={() => setIsMenuOpen(false)}
          >
            How PhoneVue
          </Link>
          <Link 
            to="/phonevue-functions" 
            className={`nav-link ${isActive('/phonevue-functions')}`}
            onClick={() => setIsMenuOpen(false)}
          >
            PhoneVue Functions
          </Link>
          <Link 
            to="/phonevue-features" 
            className={`nav-link ${isActive('/phonevue-features')}`}
            onClick={() => setIsMenuOpen(false)}
          >
            PhoneVue Features
          </Link>
          <Link 
            to="/contact-us" 
            className={`nav-link ${isActive('/contact-us')}`}
            onClick={() => setIsMenuOpen(false)}
          >
            Contact Us
          </Link>
        </nav>
        {/* <button className="search-icon" aria-label="Search">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 19L13 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button> */}
        <button 
          className={`mobile-menu-toggle ${isMenuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={isMenuOpen}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;

